export const LAYOUT_APP = {
    DEFAULT: "default",
    SOLO:"solo-page",
    LOGGED:"logged"
};